/** Project-level border radius tokens */
export const radius = {
  xs: 4,     // Extra small (minimal rounding)
  sm: 6,     // Small
  md: 8,     // Medium (default for inputs)
  lg: 12,    // Large (cards, panels)
  xl: 16,    // Extra large (modals, drawers)
  xxl: 20, // 2x large
  pill: 24,  // Pill-shaped
  full: '50%', // Fully rounded
};

export const radiusPx = {
  xs: `${radius.xs}px`,
  sm: `${radius.sm}px`,
  md: `${radius.md}px`,
  lg: `${radius.lg}px`,
  xl: `${radius.xl}px`,
  xxl: `${radius.xxl}px`,
  pill: `${radius.pill}px`,
  full: radius.full,
};
